// Display name for a saved text search: its own name, else a neutral fallback.
export function textSearchLabel(search) {
  const own = search?.name?.trim()
  return own || 'Untitled search'
}
